import { useRef, useState } from 'react';
import { Upload, Loader2, X } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';

export default function ImageUploader({ value, onChange, label = 'Product image', testId = 'image-uploader' }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Only image files are allowed'); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5 MB'); return; }
    setBusy(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const { data } = await api.post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      const fullUrl = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      onChange(fullUrl);
      toast.success('Image uploaded');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Upload failed');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div data-testid={testId}>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testId}-input`} />
      {value ? (
        <div className="flex items-center gap-3 rounded-lg border border-border bg-white p-2">
          <img src={value} alt="" className="w-14 h-14 rounded-lg object-cover"/>
          <div className="flex-1 min-w-0 text-xs text-ink/60 truncate">Image uploaded</div>
          <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange('')} className="text-ink/50 hover:text-destructive p-1"><X className="w-4 h-4"/></button>
          <button type="button" data-testid={`${testId}-replace`} onClick={() => inputRef.current?.click()} className="text-xs font-semibold text-[#D35400] hover:text-[#9A4500]">Replace</button>
        </div>
      ) : (
        <button type="button" data-testid={`${testId}-button`} disabled={busy} onClick={() => inputRef.current?.click()}
          className="w-full rounded-lg border-2 border-dashed border-border bg-white hover:border-[#E67E22] hover:bg-[#FFF7EE] transition px-3 py-4 text-sm text-ink/70 flex flex-col items-center gap-1.5">
          {busy ? <Loader2 className="w-5 h-5 animate-spin text-[#E67E22]"/> : <Upload className="w-5 h-5 text-[#E67E22]"/>}
          <span className="font-semibold">{busy ? 'Uploading…' : `Upload ${label.toLowerCase()}`}</span>
          <span className="text-[10px] uppercase tracking-[0.15em] text-ink/40">JPG, PNG, WEBP · max 5 MB</span>
        </button>
      )}
    </div>
  );
}
